/// <amd-module name="VSSUI/Components/ProgressBar/ProgressBar" />
import * as React from "react";

import { Observer } from "VSSUI/Observer";
import { css } from "VSSUI/Util";
import { IProgressBarProps } from "./ProgressBar.Props";

export const ProgressBar: React.FunctionComponent<IProgressBarProps> = (props: IProgressBarProps) => {
    return (
        <Observer currentValue={props.currentValue}>
            {(barProps: { currentValue: number }) => {
                const { transitionDuration = 150 } = props;
                return (
                    <span className={css(props.className, "bolt-progress-bar-container flex-row flex-noshrink flex-grow scroll-hidden")}>
                        <span
                            aria-label={props.ariaLabel}
                            aria-valuemin={0}
                            aria-valuemax={props.maxValue}
                            aria-valuenow={barProps.currentValue}
                            className={css(props.progressBarClassName, "bolt-progress-bar-bar")}
                            role="progressbar"
                            style={{
                                transitionDuration: `${transitionDuration}ms`,
                                transform: `scaleX(${barProps.currentValue / props.maxValue})`
                            }}
                        />
                    </span>
                );
            }}
        </Observer>
    );
};
